import { ChartLineUp, ShieldCheck, Bank, Handshake, FunnelSimple, TrendUp, UsersThree, Package } from "@phosphor-icons/react";
import { ECOMMERCE_MODULE_NAME } from "../constants/brand";

export const MODULES = [
  {
    key: "ecommerce",
    name: ECOMMERCE_MODULE_NAME,
    tagline: "Store performance, ROI recovery & client reporting",
    icon: ChartLineUp,
    status: "active",
    roles: {
      admin: "/admin/ecommerce",
      client: "/client",
      backoffice: "/backoffice",
    },
  },
  {
    key: "trust",
    name: "Trust & Asset Protection",
    tagline: "Business and personal asset protection services",
    icon: ShieldCheck,
    status: "active",
    roles: { admin: "/admin/trust", client: "/client/trust" },
  },
  {
    key: "funding",
    name: "Business Funding",
    tagline: "Funding pipeline and capital placement",
    icon: Bank,
    status: "active",
    roles: { admin: "/admin/funding", client: "/client/funding" },
  },
  {
    key: "affiliate",
    name: "Sales Reps",
    tagline: "Referral partners and affiliate payouts",
    icon: Handshake,
    status: "active",
    roles: { admin: "/admin/affiliate", client: "/client/affiliate" },
  },
  {
    key: "funding_pipeline",
    name: "Funding Pipeline",
    tagline: "Funding deals & 20% commission (SAB001)",
    icon: TrendUp,
    status: "active",
    roles: { admin: "/admin/funding-pipeline", client: "/client/funding-pipeline" },
  },
  {
    key: "leads",
    name: "Lead Pipeline",
    tagline: "Prospect intake and deal flow",
    icon: FunnelSimple,
    status: "active",
    roles: { admin: "/admin/leads" },
  },
  {
    key: "management_team",
    name: "Management Team",
    tagline: "Managers, sales reps, leads & commissions",
    icon: UsersThree,
    status: "active",
    roles: { admin: "/admin/management-team" },
  },
  {
    key: "lead_packages",
    name: "Lead Packages",
    tagline: "Package and price leads for future sale",
    icon: Package,
    status: "active",
    roles: { admin: "/admin/lead-packages" },
  },
];

export function getModulesForRole(role, unlockedKeys = []) {
  const roleKey = role === "affiliate" ? "client" : role;
  return MODULES.filter((m) => {
    if (!m.roles[roleKey]) return false;
    if (role === "affiliate") return m.key === "affiliate";
    if (roleKey !== "client") return true;
    if (m.key === "ecommerce") return true;
    return unlockedKeys.includes(m.key);
  });
}

export function getHomePathForRole(role, unlockedKeys = []) {
  if (role === "admin") return "/admin";
  if (role === "manager") return "/manager";
  if (role === "affiliate") return "/rep";
  if (role === "trust_client") return "/trust-portal/dashboard";
  const roleKey = role;
  const modules = getModulesForRole(role, unlockedKeys);
  if (modules.length === 0) return "/login";
  return modules[0].roles[roleKey];
}
